'use strict';

/**
 * there are more than a hand full of time pickers for bootstrap. But this is the best looking one that doesn't break the
 * layout of our locations page. https://www.npmjs.com/package/eonasdan-bootstrap-datetimepicker. On the raw bootstrap 3 with datetimepicker 4. https://github.com/eonasdan/bootstrap-datetimepicker.
 */
angular.module('clientDashboardApp').directive('cmdatetimepicker', () => {

  return {
    restrict: 'E',
    transclude: true,
    require: '^form',
    scope: {
      model: '=',
      boundary: '=',
      period: '=',
      skipdaterangevalidation: '@',
      placeholder: '@',
      notrequired: '@',
      updateParentSpeicalModel:'=updatemodel'
    },
    template: `
            <input  class="form-control  alspecialdate"
                      ng-model="model"
                      ng-change="updateModel()"
                      placeholder="Date"
                      data-boundary="boundary"
                      ng-required="!(notrequired === 'true')"/>
`,
    link(scope, element, attrs, formController) {

      $(element).datetimepicker({
        format: 'MM/DD/YYYY',
        useCurrent: false,
        minDate: new Date(),
        widgetPositioning: {
          vertical: "top",
          horizontal: "left"
        },
        //Play nice with BS4
        icons: {
          time: "far fa-clock",
          date: "far fa-calendar-alt",
          up: "far fa-chevron-up",
          down: "far fa-chevron-down",
          previous: "far fa-chevron-left",
          next: "far fa-chevron-right"
        },
        allowInputToggle: true,
        focusOnShow: true
      }).on('dp.change', (e) => {

        scope.model = moment(e.date._d).format("l");
        scope.updateParentSpeicalModel(scope.model, attrs.boundary)
        formController.$setDirty()


        scope.isValid = (scope.skipdaterangevalidation === "true") || scope.isValidDateRange(scope.period.specialStartDate.rawDate, scope.period.specialEndDate.rawDate)
        scope.emitValidation(scope.isValid, formController)

      })
        .on('dp.error', (err) => {
          console.log("error in date picker", err)
        })

    },//link

    controller($scope){

      $scope.dateStringTodirectiveFormat= d => moment(d).format("l")

      $scope.emitValidation = (isValid = true, formController) => {
        if (isValid){
          $scope.$emit("validateDateRange", {isValidDateRange: true})
          formController.$setValidity("specialHolidayHoursPeriod", true)
        } else {
          $scope.$emit("validateDateRange", {isValidDateRange: false})
          formController.$setValidity("specialHolidayHoursPeriod", false)
        }
      }


      $scope.isValidDateRange = (startRawDate, endRawDate) => {
        let startDate = moment(startRawDate)
        let endDate = moment(endRawDate)

        return (startDate.isSame(endDate) || startDate.isBefore(endDate))

      }
    }
  };
});
